import { ExpenseWorkflowStatusEnum } from './expense'

export interface ExpenseDeletePolicyInput {
  workflowStatus: ExpenseWorkflowStatusEnum | `${ExpenseWorkflowStatusEnum}`
  reimbursedAmount?: number | string | null
  billedInvoice?: object | null
  contractorInvoiceId?: string | null
  /** Includes reversed reimbursements which are absent from active projections. */
  hasReimbursementHistory?: boolean
  reimbursements?: readonly unknown[]
  isOwner: boolean
  canManageAll: boolean
  canDelete: boolean
}

export type ExpenseDeletePolicy =
  | { canDelete: true; reason: null }
  | { canDelete: false; reason: string }

/** Financial evidence prevents hard deletion for every role. */
export function getExpenseDeletePolicy(
  input: ExpenseDeletePolicyInput,
): ExpenseDeletePolicy {
  if (!input.canDelete)
    return {
      canDelete: false,
      reason: 'You do not have permission to delete expenses.',
    }
  if (!input.isOwner && !input.canManageAll)
    return {
      canDelete: false,
      reason: 'You can only delete your own expenses.',
    }
  if (
    input.workflowStatus !== ExpenseWorkflowStatusEnum.DRAFT &&
    input.workflowStatus !== ExpenseWorkflowStatusEnum.REJECTED
  )
    return {
      canDelete: false,
      reason: 'Only drafts or rejected expenses can be deleted',
    }
  const amount = Number(input.reimbursedAmount ?? 0)
  if (
    !Number.isFinite(amount) ||
    amount !== 0 ||
    input.billedInvoice ||
    input.contractorInvoiceId ||
    input.hasReimbursementHistory ||
    (input.reimbursements?.length ?? 0) > 0
  )
    return {
      canDelete: false,
      reason:
        'This expense has financial activity or an invoice link. Reconcile it before deletion.',
    }
  return { canDelete: true, reason: null }
}
